'use es6';

import { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
class SlidingPanelWrapper extends Component {
  constructor(props) {
    super(props);
    this.rafHandle = null;
  }
  addSeleniumSelectorIfNeeded(node) {
    if (window.SELENIUM_IS_RUNNING) {
      node.classList.add('sidebar-slidein-finished');
    }
  }
  componentWillAppear(callback) {
    const {
      transitionSpeed,
      transitionName
    } = this.props;
    const node = findDOMNode(this);
    node.classList.add(`${transitionName}-appear`);
    // More inspiration taken from CSSTransitionGroupChild
    // Set up a request animation frame handler if one doesn't already exist so we can paint
    // the first class to the DOM, and then when the browser is ready to re-paint,
    // add the -active class
    if (!this.rafHandle) {
      this.rafHandle = window.requestAnimationFrame(() => this.flushClassName(node, `${transitionName}-appear-active`));
    }
    setTimeout(() => {
      this.addSeleniumSelectorIfNeeded(node);
      callback();
    }, transitionSpeed);
  }
  componentWillEnter(callback) {
    const {
      transitionSpeed,
      transitionName
    } = this.props;
    const node = findDOMNode(this);
    node.classList.add(`${transitionName}-enter`);
    // More inspiration taken from CSSTransitionGroupChild
    // Set up a request animation frame handler if one doesn't already exist so we can paint
    // the first class to the DOM, and then when the browser is ready to re-paint,
    // add the -active class
    if (!this.rafHandle) {
      this.rafHandle = window.requestAnimationFrame(() => this.flushClassName(node, `${transitionName}-enter-active`));
    }
    setTimeout(() => {
      this.addSeleniumSelectorIfNeeded(node);
      callback();
    }, transitionSpeed);
  }
  componentWillLeave(callback) {
    const {
      transitionSpeed,
      transitionName
    } = this.props;
    const node = findDOMNode(this);
    node.classList.add(`${transitionName}-leave`);

    // This forces a repaint, ensuring that the original class styles have been applied,
    // before applying the '-active' class
    // See https://github.com/reactjs/react-transition-group/blob/1a29b40c0b4eab08a8d6ed4f10832539b09a0760/src/CSSTransitionGroupChild.js#L131-L134
    // eslint-disable-next-line no-unused-expressions
    node.scrollTop;
    node.classList.add(`${transitionName}-leave-active`);
    setTimeout(() => {
      // Sometimes WidgetEditor clears the selected item when we switch modules
      // even though we click into another module and update the selected item
      // Removing the classnames after the transition finishes makes sure that the panel
      // is there if the selected item updates as the panel is already leaving and is still
      // a rendered child because the enter/appear classes will still be applied
      node.classList.remove(`${transitionName}-leave`);
      node.classList.remove(`${transitionName}-leave-active`);
      callback();
    }, transitionSpeed);
  }
  flushClassName(node, className) {
    // This forces a repaint, ensuring that the original class styles have been applied,
    // before applying the '-active' class
    // See https://github.com/reactjs/react-transition-group/blob/1a29b40c0b4eab08a8d6ed4f10832539b09a0760/src/CSSTransitionGroupChild.js#L131-L134
    // eslint-disable-next-line no-unused-expressions
    node.scrollTop;
    node.classList.add(className);
    this.rafHandle = null;
  }
  render() {
    const {
      isReadOnlyMode,
      isOpen,
      children,
      isPatagonia
    } = this.props;
    const sidebarContentClasses = 'inner-sliding-panel' + (isReadOnlyMode ? " read-only" : "");
    if (!isOpen) {
      return null;
    }
    const sidebarPanelClass = !isPatagonia ? 'sliding-edit-panel' : '';
    return /*#__PURE__*/_jsx("div", {
      className: sidebarPanelClass,
      style: {
        height: '100%'
      },
      children: /*#__PURE__*/_jsx("div", {
        className: sidebarContentClasses,
        children: children
      })
    });
  }
}
SlidingPanelWrapper.propTypes = {
  transitionSpeed: PropTypes.number.isRequired,
  transitionName: PropTypes.string.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  isPatagonia: PropTypes.bool
};
export default SlidingPanelWrapper;